/**
 * Validates if a string is a valid URL.
 *
 * @param url - The URL string to validate.
 * @returns True if the URL is valid, false otherwise.
 *
 * @example
 * ```typescript
 * isValidUrl("https://example.com") // true
 * isValidUrl("not-a-url")           // false
 * ```
 */
export function isValidUrl(url: string): boolean {
  try {
    new URL(url)
    return true
  } catch {
    return false
  }
}
